module.exports = __webpack_public_path__ + "static/media/imagem14.a9159083.jpeg";